import React from 'react';
import Input, { InputProps } from './Input';

const TextInput = ({ ...props }: InputProps) => <Input {...props} type="text" />;

export default TextInput;
